define(function(require) {
    const BaseCell = require('../BaseCell');
    const _ = require('underscore');

    /**
     * Basic Cell
     * @param {Object} options
     * @returns column definition
     */
    const Cell = function(options) {
        return {
            CellClass: BaseCell,
            options: _.extend({}, options)
        };
    };
    return Cell;
});
